import { useEffect, useState } from "react";
import { MdCheckCircle, MdError, MdInfo, MdWarning, MdClose } from "react-icons/md";
import "../../styles/Show_Snackbar.css";

export default function Snackbar({ message, type = "info", open, onClose, className = "" }: any) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setVisible(true);

      const duration = type === "error" ? 5000 : 3500;
      const timer = setTimeout(() => {
        setVisible(false);
        onClose?.();
      }, duration);

      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [open, onClose, type]);

  if (!visible || !message) return null;

  const renderIcon = () => {
    if (type === "success") return <MdCheckCircle size={20} style={{ flexShrink: 0, marginRight: 8 }} />;
    if (type === "error") return <MdError size={20} style={{ flexShrink: 0, marginRight: 8 }} />;
    if (type === "warning") return <MdWarning size={20} style={{ flexShrink: 0, marginRight: 8 }} />;
    return <MdInfo size={20} style={{ flexShrink: 0, marginRight: 8 }} />;
  };

  return (
    <div className={`snackbar show ${type} ${className}`}>
      <div style={{ display: "flex", alignItems: "center", width: "100%", gap: "8px" }}>
        {renderIcon()}
        <span style={{ flex: 1, textAlign: "left", lineHeight: 1.4 }}>{message}</span>
        <button
          type="button"
          onClick={() => {
            setVisible(false);
            onClose?.();
          }}
          style={{
            background: "none",
            border: "none",
            color: "currentColor",
            cursor: "pointer",
            padding: "2px 4px",
            opacity: 0.85,
            display: "flex",
            alignItems: "center",
          }}
          title="Dismiss"
        >
          <MdClose size={18} />
        </button>
      </div>
    </div>
  );
}
